export default __webpack_public_path__ + "static/media/logo_new.032088cd.svg";